// extracted by mini-css-extract-plugin
export default {"root":"App_root__40Hjl","cardContainer":"App_cardContainer__5M2I6","cardTitle":"App_cardTitle__clYGt"};